import { createEffect, createMemo, createResource } from "solid-js"
import { getSessionContextByRemote, updateSessionAccountingContext } from "@/cowork/api"

function remoteSessionID(path: string) {
  const match = path.match(/\/session\/([^/?#]+)/)
  if (!match) return
  try { return decodeURIComponent(match[1]) } catch { return }
}

export function CoworkChatContext(props: { path: string; workspacePath: string; active: boolean }) {
  const [context] = createResource(
    () => props.active ? remoteSessionID(props.path) : undefined,
    (id) => getSessionContextByRemote(id),
  )
  const current = createMemo(() => {
    const value = context()
    if (!value || value.remote_opencode_session_id !== remoteSessionID(props.path)) return
    const agent = value.session_metadata.agent as { template_id?: string } | undefined
    if (agent?.template_id !== "accounting" || value.session_metadata.workflow_run_id || !value.project_id) return
    return value
  })
  let viewSynced = ""
  createEffect(() => {
    const value = current()
    if (!value || !props.active) return
    const view = props.workspacePath.split("/").filter(Boolean).find((part) =>
      ["files", "billing", "books", "reports"].includes(part)) as "files" | "billing" | "books" | "reports" | undefined
    const next = `${value.session_id}:${view ?? "other"}`
    const stored = value.session_metadata.accounting_context as { active_view?: string } | undefined
    if (stored?.active_view === (view ?? "other")) { viewSynced = next; return }
    if (viewSynced === next) return
    viewSynced = next
    void updateSessionAccountingContext(value.project_id, value.session_id, { active_view: view ?? "other" }).catch(() => {
      viewSynced = ""
    })
  })
  return null
}
